// src/services/suratKargoService.js
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// ⚠️ MOCK MODE - Şifreler gelene kadar true, sonra false yap
const MOCK_MODE = false;

/**
 * 📦 Kargo Gönderisi Oluştur
 */
/**
 * 📦 Kargo Gönderisi Oluştur
 */
export const createShipment = async (orderData) => {
  try {
    // ✅ MOCK MODE
    if (MOCK_MODE) {
      console.log('⚠️ MOCK MODE: Kargo oluşturma simülasyonu...');
      console.log('📦 OrderData:', {
        orderNumber: orderData.orderNumber,
        shippingAddress: orderData.shippingAddress
      });
      
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const mockTrackingNumber = `MOCK-SK-${Date.now()}`;
      
      return {
        success: true,
        trackingNumber: mockTrackingNumber,
        shipmentDate: new Date().toISOString(),
        carrier: 'Sürat Kargo (TEST)',
        mock: true
      };
    }
    
    // ✅ GERÇEK API
    console.log('📦 Sürat Kargo gönderisi oluşturuluyor (GERÇEK)...');
    console.log('📋 Gönderilecek orderData:', {
      orderNumber: orderData.orderNumber,
      hasShippingAddress: !!orderData.shippingAddress,
      city: orderData.shippingAddress?.city,
      district: orderData.shippingAddress?.district
    });
    
    const createShipmentFn = httpsCallable(functions, 'createShipment');
    
    // ✅ Backend'in beklediği format: { orderData: {...} }
    const result = await createShipmentFn({ orderData: orderData });
    
    console.log('✅ Sürat Kargo yanıtı:', result.data);
    
    return result.data;
    
  } catch (error) {
    console.error('❌ Sürat Kargo hatası:', error);
    return {
      success: false,
      error: error.message || 'Kargo oluşturulamadı'
    };
  }
};

/**
 * 🔍 Kargo Takip
 */
export const trackShipment = async (trackingNumber) => {
  try {
    // ✅ MOCK MODE - Test için sahte takip bilgisi
    if (MOCK_MODE) {
      console.log('⚠️ MOCK MODE: Sahte takip bilgisi döndürülüyor...');
      console.log('🔍 Takip No:', trackingNumber);
      
      // API simülasyonu
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Sahte takip geçmişi
      const mockTracking = {
        status: 'in_transit',
        statusText: 'Kargo Yolda',
        lastUpdate: new Date().toISOString(),
        estimatedDelivery: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 gün sonra
        events: [
          {
            date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
            description: 'Kargo şubeye teslim edildi',
            location: 'Antalya Manavgat Şube',
            status: 'received'
          },
          {
            date: new Date(Date.now() - 1.5 * 24 * 60 * 60 * 1000).toISOString(),
            description: 'Kargo transfer merkezine gönderildi',
            location: 'Antalya Transfer Merkezi',
            status: 'in_transit'
          },
          {
            date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
            description: 'Transfer merkezinde işleme alındı',
            location: 'Antalya Transfer Merkezi',
            status: 'processing'
          },
          {
            date: new Date(Date.now() - 0.5 * 24 * 60 * 60 * 1000).toISOString(),
            description: 'Kargo dağıtım şubesine ulaştı',
            location: 'Hedef Şube',
            status: 'at_branch'
          },
          {
            date: new Date().toISOString(),
            description: 'Kargo dağıtıma çıkarılmak üzere hazırlanıyor',
            location: 'Hedef Şube - Dağıtım Hazırlık',
            status: 'preparing_delivery'
          }
        ]
      };
      
      console.log('✅ MOCK: Takip bilgisi döndürüldü');
      
      return {
        success: true,
        tracking: mockTracking,
        mock: true
      };
    }
    
    // ✅ GERÇEK API
    console.log('🔍 Kargo takibi sorgulanıyor (GERÇEK)...');
    
    const trackShipmentFn = httpsCallable(functions, 'trackShipment');
    const result = await trackShipmentFn({ trackingNumber });
    
    console.log('✅ Takip bilgisi alındı:', result.data);
    
    return result.data;
    
  } catch (error) {
    console.error('❌ Takip hatası:', error);
    return {
      success: false,
      error: error.message || 'Takip bilgisi alınamadı'
    };
  }
};

/**
 * 🔄 Toplu Kargo Durumu Güncelle
 */
export const updateAllShipments = async (orders) => {
  try {
    if (MOCK_MODE) {
      console.log('⚠️ MOCK MODE: Toplu güncelleme simüle ediliyor...');
      
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const mockUpdates = orders
        .filter(order => order.trackingNumber && order.status === 'shipped')
        .map(order => ({
          orderId: order.id,
          trackingNumber: order.trackingNumber,
          updated: true,
          mock: true
        }));
      
      return {
        success: true,
        updates: mockUpdates,
        mock: true
      };
    }
    
    // GERÇEK API
    console.log(`🔄 ${orders.length} sipariş için kargo durumu güncelleniyor...`);
    
    const updateAllShipmentsFn = httpsCallable(functions, 'updateAllShipments');
    const result = await updateAllShipmentsFn({ orders });
    
    return result.data;
    
  } catch (error) {
    console.error('❌ Toplu güncelleme hatası:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const cancelShipment = async (trackingNumber, reason = 'Sipariş iptali') => {
  try {
    // ✅ MOCK MODE
    if (MOCK_MODE) {
      console.log('⚠️ MOCK MODE: Kargo iptal simülasyonu...');
      console.log('🚫 İptal edilecek takip no:', trackingNumber);
      console.log('📝 İptal nedeni:', reason);
      
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      return {
        success: true,
        message: 'Kargo başarıyla iptal edildi (MOCK)',
        trackingNumber: trackingNumber,
        mock: true
      };
    }
    
    // ✅ GERÇEK API
    console.log('🚫 Kargo iptal ediliyor (GERÇEK)...');
    console.log('📦 Takip No:', trackingNumber);
    console.log('📝 Neden:', reason);
    
    const cancelShipmentFn = httpsCallable(functions, 'cancelShipment');
    const result = await cancelShipmentFn({ trackingNumber, reason });
    
    console.log('✅ Kargo iptal yanıtı:', result.data);
    
    return result.data;
    
  } catch (error) {
    console.error('❌ Kargo iptal hatası:', error);
    return {
      success: false,
      error: error.message || 'Kargo iptal edilemedi',
      requiresManualCheck: true
    };
  }
};

// ✅ Mock mode durumunu kontrol etmek için
export const isMockMode = () => MOCK_MODE;

// ✅ Mock mode'u değiştirmek için (geliştirme amaçlı)
export const setMockMode = (enabled) => {
  console.warn(`🔄 MOCK MODE ${enabled ? 'AÇILDI' : 'KAPATILDI'}`);
  // Bu fonksiyon sadece console'da uyarı verir
  // Gerçek değişiklik için dosyayı düzenlemelisiniz
};

export default {
  createShipment,
  trackShipment,
  updateAllShipments,
  isMockMode,
  setMockMode,
  cancelShipment
};